import React, { 
  useMemo, useState, forwardRef 
} from 'react';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import { FieldArrayDndFormik, FieldCustom, FieldTextarea } from 'components/molecules';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use'
import { useFormikForwardRef } from 'hooks'

const ItemSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Mínimo de 2 caracteres')
    .max(100, 'Máximo de 100 caracteres')
    .required('Campo Obrigatório'),
  content: Yup.string().required('Campo Obrigatório'),
  href: Yup.string()
    .matches(/^(https?:\/\/)?(\s*)?[-a-zA-Z0-9_@:?&%.+~#=/]*$/, 'Url inválido')
    .nullable()
    .notRequired(),
  buttonTitle: Yup.string()
});

// eslint-disable-next-line react/prop-types
const ItemForm = forwardRef(({ initialValues, onSubmit }, ref) => {
  // this is necessary for all FieldArrayDnd forms
  // in order to control the submitForm from parent
  const formRef = useFormikForwardRef(ref);

  return (
    <Formik
      ref={formRef}
      initialValues={initialValues}
      validationSchema={ItemSchema}
      onSubmit={(values, { setSubmitting }) => {
        const { href, buttonTitle } = values

        let newButtonTitle = buttonTitle;
        if (href === '' && buttonTitle === '') {
          newButtonTitle = null
        } else if (buttonTitle === '') {
          newButtonTitle = 'Saber Mais'
        }
        onSubmit({
          ...values,
          href: href || null,
          buttonTitle: newButtonTitle
        });
        setSubmitting(false);
      }}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <Field
          title="Texto*"
          name="title"
          info="Título"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          title="Descrição*"
          name="content"
          info="Texto"
          component={FieldTextarea}
        />
        <Field
          title="Link (opcional)"
          name="href"
          info="Link de destino"
          component={FieldCustom}
        />
        <Field
          title="Título do Botão (opcional)"
          name="buttonTitle"
          info="Mensagem que aparece no botão com o link. Deixe vazio para assumir valor padrão : Saber Mais"
          component={FieldCustom}
        />
      </Form>
    </Formik>
  )
})

const CardsSchema = Yup.object().shape({
  data: Yup.array().of(Yup.object().shape({ title: Yup.string(), content: Yup.string() }))
    .required('Campo obrigatório'),
});

const CardsEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)

  const initialValues = useMemo(() => {
    const { title, data } = initialProps;
    return { title, data };
  }, [initialProps]);


  const handleFormChange = newValues => {
    const newProps = { ...initialProps, ...newValues };
    const isValid = CardsSchema.isValidSync(newValues)
    if (isValid) setEditorProps(newProps)
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={CardsSchema}
      validate={handleFormChange}
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          info="Uma frase para secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          name="data"
          component={FieldArrayDndFormik}
          columns={[
            {
              accessor: 'title',
              Header: 'Título',
            },
            {
              accessor: 'content',
              Header: 'Descrição',

            }
          ]}
          rowKey="title"
          ItemForm={ItemForm}
        />
      </Form>
    </Formik>
  );
};
CardsEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    source: PropTypes.string,
  }),
};

CardsEditor.defaultProps = {
  initialProps: {},
};

export default CardsEditor;
